import React, { JSX } from 'react';
import { FormConfig, PhoneInputElement } from '../types/types';
import FormPhoneInput from './FormPhoneInput';

interface Props {
  config: PhoneInputElement;
  keySuffix?: FormConfig['keySuffix'];
}

const PhoneInputWrapper = (props: Props): JSX.Element => {
  const {
    config: {
      id,
      key,
      ariaLabel,
      label,
      boldLabel,
      showErrorIcon,
      disabled,
      helperText,
      validateOnBlurOnly,
      showSuccessState,
      defaultCountry,
      noResultsText
    },
    keySuffix
  } = props;

  return (
    <FormPhoneInput
      id={id}
      ariaLabel={ariaLabel}
      name={`${key}${keySuffix || ''}`}
      prefixName={`${key}CountryPrefix${keySuffix || ''}`}
      label={label}
      boldLabel={boldLabel}
      showErrorIcon={showErrorIcon}
      disabled={disabled}
      helperText={helperText}
      validateOnBlurOnly={validateOnBlurOnly}
      showSuccessState={showSuccessState}
      defaultCountry={defaultCountry || 'DE'}
      noResultsText={noResultsText}
    />
  );
};

export default PhoneInputWrapper;
